module.exports = __webpack_public_path__ + "static/after-sales-banner-38eb96091aede98921095f57b337fe2d.png";